import script from "./BetAmount.vue?vue&type=script&setup=true&lang=js"
export * from "./BetAmount.vue?vue&type=script&setup=true&lang=js"

import "./BetAmount.vue?vue&type=style&index=0&id=8c015f10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c015f10"]])

export default __exports__